<template>
    <v-container>
        <v-card-title>
            Sample requests
            <v-spacer></v-spacer>
            <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
            ></v-text-field>
        </v-card-title>
        <v-data-table
                :headers="headers"
                :items="samples.data"
                :search="search"
                :pagination.sync="pagination"
                hide-actions
                :loading="loading"
                :total-items="8"
                v-on:update:pagination="ordenar"
        >
            <template slot="items" slot-scope="props">
                <td>{{ props.item.request_ }}</td>
                <td class="text-xs">{{ props.item.status_name }}</td>
                <td class="layout px-0 justify-end align-center">
                    <v-menu
                            transition="slide-y-transition"
                            bottom
                            left
                    >
                        <v-btn
                                slot="activator"
                                color="primary"
                                dark
                                fab
                                flat
                        >
                            <v-icon>settings</v-icon>
                        </v-btn>
                        <v-list>
                            <v-list-tile>
                                <v-btn flat block @click="editStatus = true, newStatus = props.item.status.id"><v-icon left>border_color</v-icon>Change status</v-btn>
                            </v-list-tile>
                            <v-list-tile>
                                <v-btn flat block :to="{ name: 'admin.samples.detail', params : { id : props.item.id }, query: { model: 'tab-documents' } }"><v-icon left>description</v-icon>Documents</v-btn>
                            </v-list-tile>
                            <v-list-tile>
                                <v-btn flat block :to="{ name: 'admin.samples.detail', params : { id : props.item.id }, query: { model: 'tab-info' } }"><v-icon left>shopping_cart</v-icon>Products</v-btn>
                            </v-list-tile>
                            <v-list-tile>
                                <v-btn flat block :to="{ name: 'admin.samples.detail', params : { id : props.item.id } }"><v-icon left>remove_red_eye</v-icon>Details</v-btn>
                            </v-list-tile>
                        </v-list>
                    </v-menu>

                    <v-dialog v-model="editStatus" persistent max-width="600px">
                        <v-card>
                            <v-card-title>
                                <span class="headline">Change status</span>
                            </v-card-title>
                            <v-card-text>
                                <v-container grid-list-md>
                                    <v-layout wrap>
                                        <v-flex xs12 sm12>
                                            <v-autocomplete
                                                    :items="statuses"
                                                    label="Sample order statutes"
                                                    item-text="name"
                                                    item-value="id"
                                                    v-model="newStatus"
                                            ></v-autocomplete>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" @click.native="changeStatusOrder(props.item.id)">Change status</v-btn>
                                <v-btn color="red" @click.native="editStatus = false">Cancel</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                Your search for "{{ search }}" found no results.
            </v-alert>
        </v-data-table>
        <div class="text-xs-center pt-4 pb-4" v-if="samples.data">
            <v-pagination
                    @input="setPage"
                    v-model="page"
                    :length="last_page"
                    color="secondary"
                    circle
                    :total-visible="7"
            ></v-pagination>
            <p class="subtitle">Showing {{ samples.meta.from }} to {{ samples.meta.to }} of {{ samples.meta.total }} entries</p>
        </div>
    </v-container>
</template>

<script>
    export default {
        props: ['id'],
        data () {
            return {
                dialog: true,
                samples: [],
                search: '',
                headers: [
                    {
                        text: 'Sample request',
                        align: 'left',
                        sortable: true,
                        value: 'request_'
                    },
                    { text: 'Status', value: 'status_id' },
                    { text: 'Actions', value: 'action', align: 'right', sortable: false }
                ],
                page: null,
                last_page: null,
                pagination: {},
                loading: false,
                fab: [],
                fling: false,
                hover: false,
                tabs: null,
                top: false,
                right: true,
                bottom: true,
                left: false,
                transition: 'slide-x-transition',
                direction: 'left',
                statuses: null,
                editStatus: false,
                newStatus: null,
                sortBy: 'request_',
                order: 'asc',
            }
        },
        created () {
            this.getSampleOrderStatuses();
            this.getSamples();
            this.debouncedGetSamples = _.debounce(this.getSamples, 500)
        },
        watch: {
            search: function () {
                this.loading = true;
                this.debouncedGetSamples();
            },
            last_page: function () {
                if (this.page > this.samples.meta.last_page) {
                    this.page = 1;
                }
            }
        },
        methods : {
            ordenar (payload) {
                this.sortBy = payload.sortBy;
                if (payload.descending) {
                    this.order = 'desc';
                } else {
                    this.order = 'asc';
                }
                this.getSamples();
            },
            setPage (page) {
                this.page = page;
                this.getSamples();
            },
            getSamples () {
                var params = {
                    filters : {
                        search: this.search,
                        page: this.page,
                        sortBy: this.sortBy,
                        order: this.order
                    },
                    id: this.id
                };

                this.$store.dispatch('getSamplesClient', params).then((res) => {

                    this.samples = res.data;
                    this.loading = false;
                    this.page = res.data.meta.current_page;
                    this.last_page = res.data.meta.last_page;
                    this.loading = false;

                    this.fab = [];

                    for (var i = 0; i < res.data.data.length; i++) {
                        this.fab.push(false);
                    }

                }).catch((error) => {

                });
            },
            getSampleOrderStatuses () {
                this.$store.dispatch('getStatusSampleOrders').then((res) => {
                    this.statuses = res.data.data;
                }).catch((error) => {

                });
            },
            changeStatusOrder(id) {
                this.$store.dispatch('updateStatusSampleOrders', {
                    id: id,
                    status: this.newStatus
                }).then((res) => {
                    this.$store.dispatch('setSnackBarText', {
                        text: 'Status change successfully.'
                    });
                    this.$store.dispatch('activeSnack')
                    this.getSamples();
                    this.newStatus = null;
                    this.editStatus = false;
                }).catch((error) => {
                    this.$store.dispatch('setSnackBarText', {
                        text: error.data.mensaje
                    });
                    this.$store.dispatch('activeSnack')
                });
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/admin/clients/view/SamplesComponent.vue